import { Col, Collapse, Descriptions, Drawer, Row } from 'antd';
import React from 'react';
import ConfirmButton from './confirm-button';
import _capitalize from "lodash/capitalize";
import { NACH_STATUS } from '../constants/enums';
const { Panel } = Collapse;

export default class NachDetailsDrawer extends React.Component {
    render() {
        const { visible , onClose, triggerEnach, nachData, nachStatusResponse, triggerNachLoader} = this.props;

        return (
            <Drawer
                width={"70%"}
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
            >
                <Row>
                    <Col span="24" className='justify-content-space-between d-flex'>
                        <h3 style={{ marginBottom: 24 }}>Mandate Details</h3>
                        <ConfirmButton
                            descriptionColor={[NACH_STATUS.get('VERIFIED'), NACH_STATUS.get('BANK_CONFIRMED')].includes(nachStatusResponse  ? nachStatusResponse.getNachStatus() : '') ? 'red' : null}
                            loading={triggerNachLoader}
                            type={"primary"}
                            label="Trigger"
                            onConfirm={() => triggerEnach()}
                            description={ 
                                [NACH_STATUS.get('VERIFIED'), NACH_STATUS.get('BANK_CONFIRMED')].includes(nachStatusResponse ? nachStatusResponse.getNachStatus() : '')  
                                ? `NACH is already registered via ${nachStatusResponse.getMandateTypeLabel()} mode. Do you wish to initiate again?`  
                                : "Are you sure you want to Trigger E-Nach"}
                        />
                    </Col>
                </Row>
                <Collapse defaultActiveKey={nachData ? nachData.get("data").map((_, key) => key).toList().toJS() : []}>
                    {nachData && nachData.get("data") && nachData.get("data").size && nachData.get("data").map((_, key) =>
                        <Panel key={key} header={_capitalize(key.split('_').join(' '))}>
                            <Descriptions bordered>
                                {Object.keys(_).map(__ =>
                                    <Descriptions.Item label={_[__].label}>{_[__].value || '--'}</Descriptions.Item>
                                )}
                            </Descriptions>
                        </Panel>
                    ).toList()}
                </Collapse>
            </Drawer>
        )
    }
}